import { Dayjs } from "dayjs";
import { z } from "zod";

export type Timespan = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
};

export const PeriodOptionSchema = z.enum([
  "custom",
  "last_day",
  "last_7_days",
  "last_28_days",
  "last_18_months",
  "prev_month"
]);

export type PeriodOptionType = z.infer<typeof PeriodOptionSchema>;
